import { Component, Input, OnInit, SimpleChanges } from "@angular/core";

@Component({
  selector: "kwikui-label-value-pair-placeholder",
  templateUrl: "./label-value-pair-placeholder.component.html",
  styleUrls: ["./label-value-pair-placeholder.component.css"]
})
export class LabelValuePairPlaceholderComponent implements OnInit {
  @Input()
  placeholder;

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.hasOwnProperty("placeholder") &&
      !changes.placeholder.firstChange
    ) {
      this.placeholder = changes.placeholder.currentValue;
    }
  }
}
